import React from 'react';
import './Popup.css';

const Popup = ({ message, type, onClose }) => {
    return (
        <div className={`popup-overlayMsg ${type}`}>
            <div className="popup-contentMsg">
                <p>{message}</p>
                <button onClick={onClose}>OK</button>
            </div>
        </div>
    );
};

export default Popup;
